import { render, staticRenderFns } from "./AnnouncementTranslate.vue?vue&type=template&id=27821815&scoped=true"
import script from "./AnnouncementTranslate.vue?vue&type=script&lang=js"
export * from "./AnnouncementTranslate.vue?vue&type=script&lang=js"
import style0 from "./AnnouncementTranslate.vue?vue&type=style&index=0&id=27821815&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27821815",
  null
  
)

export default component.exports